<template>
  <pf-description-list-group v-if="totali[durata].scontato > 0">
    <pf-description-list-term>
      {{ label }}
    </pf-description-list-term>
    <pf-description-list-description class="pf-v6-u-text-align-end">
      <pf-content>
        <s v-if="hasSconto">
          {{ $currency(totali[durata].listino, currency) }}
        </s>
        {{ ' ' }}
        <span :class="{big}">{{ $currency(totali[durata].scontato, currency) }}</span>
        <span class="vat"><template v-if="vat"> + {{ $t('IVA') }}</template> / {{ $t(durataLabel) }}</span>
      </pf-content>
    </pf-description-list-description>
  </pf-description-list-group>
</template>

<style scoped>
.big {
  font-weight: var(--pf-v6-c-content--heading--m-page-title--FontWeight);
  font-size: var(--pf-v6-c-content--h2--FontSize);
}
</style>

<script lang="ts" setup>
import { $t as _t } from '@/i18n';
import type { OfferTotals } from "@/resources";
import { computed } from "vue";
import { type PRODOTTIANAGRAFICA_DURATA } from '../common/consts';

const props = withDefaults(defineProps<{
  totali: OfferTotals;
  durata: typeof PRODOTTIANAGRAFICA_DURATA[number];
  currency: 'CHF' | 'EUR';
  label?: string;
  vat?: boolean;
  big?: boolean;
}>(), {
  label: _t('Nuovo totale a te riservato'),
});

const hasSconto = computed(() => props.totali[props.durata].listino != props.totali[props.durata].scontato);
const durataLabel = computed(() => props.durata === 'Mensile' ? _t('Mese') : props.durata === 'Annuale' ? _t('Anno') : _t('Una tantum'));
</script>
